import React from 'react';
import PropTypes from 'prop-types';
import style from './style.css';
import MenuItem from './menu-item';
import classnames from 'classnames';

// We need a ref to this component, so it must not be functional.
// See https://reactjs.org/docs/refs-and-the-dom#refs-and-functional-components
class DropDownMenu extends React.Component {
  render() {
    const { children, className, isOpen, toggle } = this.props;

    return (
      <div
        className={ classnames(style.dropDown, className) }
      >
        <button className={ style.toggleButton } onClick={ toggle }>&#8942;</button>
        {
          isOpen
            ? (
              <ul className={ style.content }>
                { children }
              </ul>
            ) : (
              null
            )
        }
      </div>
    );
  }
}

DropDownMenu.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.instanceOf(MenuItem),
    PropTypes.array,
  ]),
  className: PropTypes.string,
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default DropDownMenu;



// WEBPACK FOOTER //
// ./client/src/components/drop-down-menu/index.js